import { Link, LinkProps } from '@chakra-ui/react';
import {
    DISCLOSURES_LINK,
    PRIVACY_POLICY_LINK,
    TERMS_OF_SERVICE_LINK,
} from '@common/compliance';

export default function GeneralDisclosuresLink(props: LinkProps) {
    return (
        <>
            <Link
                href={DISCLOSURES_LINK}
                target="_blank"
                textDecoration="underline"
                {...props}
            >
                full disclosures here
            </Link>
            {', '}
            <Link
                href={TERMS_OF_SERVICE_LINK}
                target="_blank"
                textDecoration="underline"
                {...props}
            >
                terms of service
            </Link>
            {' and '}
            <Link
                href={PRIVACY_POLICY_LINK}
                target="_blank"
                textDecoration="underline"
                {...props}
            >
                privacy policy
            </Link>
        </>
    );
}
